import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth';
import { Layout } from './components/Layout';
import { Aujourdhui } from './pages/Aujourdhui';
import { Login } from './pages/Login';
import { PatientDetail } from './pages/PatientDetail';
import { PatientForm } from './pages/PatientForm';
import { Patients } from './pages/Patients';
import { Pointage } from './pages/Pointage';
import { Rapport } from './pages/Rapport';
import { Reglages } from './pages/Reglages';
import { RendezVous } from './pages/RendezVous';
import { Semaine } from './pages/Semaine';
import { UnloggedProvider } from './unlogged';

function Routed() {
  const { status } = useAuth();

  if (status === 'loading') {
    return <p className="boot">Chargement…</p>;
  }

  if (status === 'anonymous') {
    return <Login />;
  }

  return (
    <UnloggedProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Navigate to="/aujourdhui" replace />} />
          <Route path="/aujourdhui" element={<Aujourdhui />} />
          <Route path="/semaine" element={<Semaine />} />
          <Route path="/pointage" element={<Pointage />} />
          <Route path="/patients" element={<Patients />} />
          <Route path="/patients/nouveau" element={<PatientForm />} />
          <Route path="/patients/:id" element={<PatientDetail />} />
          <Route path="/patients/:id/modifier" element={<PatientForm />} />
          <Route path="/rdv/nouveau" element={<RendezVous />} />
          <Route path="/rdv/:id" element={<RendezVous />} />
          <Route path="/rapport" element={<Rapport />} />
          <Route path="/reglages" element={<Reglages />} />
          <Route path="*" element={<Navigate to="/aujourdhui" replace />} />
        </Route>
      </Routes>
    </UnloggedProvider>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routed />
      </AuthProvider>
    </BrowserRouter>
  );
}
